import script from "./DropdownBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./DropdownBar.vue?vue&type=script&lang=ts&setup=true"

import "./DropdownBar.vue?vue&type=style&index=0&id=0d9c5bc0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9c5bc0"]])

export default __exports__